// extracted by mini-css-extract-plugin
export default {"reportsPage":"ReportsPage_reportsPage__AvTkO","content":"ReportsPage_content__K8MOc","container":"ReportsPage_container__-vLmg","description":"ReportsPage_description__Jt79g"};